import React, { useState } from 'react';
import styles from './styles.module.scss'; // Importing the SCSS module
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const Checkbox = ({ label, checked, onChange }) => {
  const [isChecked, setIsChecked] = useState(checked || false);

  const handleCheckboxChange = () => {
    setIsChecked((prevState) => !prevState);
    if (onChange) onChange(!isChecked); // Callback function to parent component if needed
  };

  return (
    <label className={styles.checkboxContainer}>
      <input
        type="checkbox"
        className={styles.checkbox}
        checked={isChecked}
        onChange={handleCheckboxChange}
      />
      <span className={styles.checkmark}>
        {isChecked && <FontAwesomeIcon icon={faCheck} />}
      </span>
      {label && <span className={styles.labelText}>{label}</span>}
    </label>
  );
};

export default Checkbox;
